import React, { useState } from "react";
import styled from "styled-components";
import { Link } from "react-scroll";
import { MapPinHouse, PhoneCall, Smartphone } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function Contact() {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  //qdbc zasp tquu trmv
  // const QUALIOPI =
  //   "https://valacademy.s3.us-east-1.amazonaws.com/PDF/QUALIOPI.pdf"; // Your S3 PDF link
  const CATALOGUE =
    "https://valacademy.s3.us-east-1.amazonaws.com/PDF/CATALOGUE.pdf";
  return (
    <Wrapper>
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
          <div
            style={{ marginTop: "5%" }}
            className="bg-white w-full max-w-2xl max-h-[80vh] overflow-y-auto rounded-xl shadow-lg p-6 relative"
          >
            <h2
              className="text-xl font-semibold mb-4"
              style={{ color: "#f8a300" }}
            >
              Terms & Conditions
            </h2>

            <div className="text-sm text-gray-700 space-y-4">
              {/* Replace this with your actual content */}
              <p>
                En utilisant ce formulaire de contact, vous acceptez que vos
                informations soient utilisées pour répondre à votre demande.
              </p>
              {/* Add more sections as needed */}
            </div>

            {/* Close Button */}
            <button
              onClick={() => setIsOpen(false)}
              className="absolute top-2 right-2 text-gray-500 hover:text-red-500 text-xl"
            >
              &times;
            </button>
          </div>
        </div>
      )}
      <div style={{ backgroundColor: "transparent" }}>
        <div className="container">
          <InnerWrapper>
            <FooterContent>
              <ColumnWrapper>
                <Column>
                  <SectionTitle>Qualité et certification</SectionTitle>
                  <a href={"/"} className="pdf-link">
                    <CertificationImageWrapper>
                      <img
                        src={require("../../assets/img/Qualiopi.webp")}
                        alt="Certification"
                        width="180"
                        height="100"
                      />
                    </CertificationImageWrapper>
                    <StyleP>Certification professionnelle reconnue</StyleP>
                  </a>
                  <StyleP>Formation continue et sur-mesure pour adultes</StyleP>
                </Column>

                <Column>
                  <SectionTitle>Nos offres</SectionTitle>
                  <StyleP>Inter-entreprise</StyleP>
                  <StyleP>Intra-entreprise</StyleP>
                  <StyleP>Sur-mesure</StyleP>
                  <StyleP>Diplômante</StyleP>
                  <StyleP>Digital Learning</StyleP>
                  <StyleP>VAE</StyleP>
                </Column>

                <Column>
                  <SectionTitle>À propos de Valacademy Formations</SectionTitle>
                  <StyleP
                    style={{
                      textDecorationLine: "underline",
                      textDecorationColor: "white",
                    }}
                    className="row"
                  >
                    <PhoneCall size={18} style={{ marginRight: 5 }} />
                    <a
                      href="tel:+33162370262"
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      0162370262
                    </a>
                  </StyleP>
                  <StyleP
                    className="row"
                    style={{
                      textDecorationLine: "underline",
                      textDecorationColor: "white",
                    }}
                  >
                    <Smartphone size={18} style={{ marginRight: 5 }} />
                    <a
                      href="tel:+33658684043"
                      style={{
                        textDecoration: "none",
                        color: "inherit",
                      }}
                    >
                      0658684043
                    </a>
                  </StyleP>
                  <StyleP
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      flexWrap: "wrap",
                      gap: "5px",
                      whiteSpace: "normal",
                      cursor: "pointer",
                      textDecorationLine: "underline",
                    }}
                    onClick={() =>
                      window.open(
                        "https://www.google.com/maps/place/2+Av.+Lénine,+93230+Romainville,+France",
                        "_blank"
                      )
                    }
                  >
                    <MapPinHouse size={18} />
                    <span>2</span>
                    <span>Avenue</span>
                    <span>Lenine</span>
                    <span>93230</span>
                    <span>Romainville</span>
                  </StyleP>
                </Column>

                <Column>
                  <SectionTitle>Aides</SectionTitle>
                  <StyleP>FAQ</StyleP>

                  <StyleP style={{ cursor: "pointer" }}>
                    <Link style={{ color: "white" }} to="contact" smooth={true}>
                      Nous contacter
                    </Link>
                  </StyleP>
                  <StyleP>Bulletin d'inscription</StyleP>
                  <StyleP
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "5px",
                      whiteSpace: "normal",
                      cursor: "pointer",
                      textDecorationLine: "underline",
                    }}
                  >
                    <a
                      href={CATALOGUE}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="pdf-link"
                      style={{ color: "white" }}
                    >
                      Catalogues PDF
                    </a>
                  </StyleP>
                  <br />
                  <StyleP
                    style={{
                      display: "inline-flex",
                      alignItems: "center",

                      gap: "5px",
                      whiteSpace: "normal",
                      cursor: "pointer",
                      textDecorationLine: "underline",
                    }}
                    onClick={() => navigate("/mentions_legales")}
                  >
                    Mentions Legales
                  </StyleP>
                  <br />
                  <StyleP
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      flexWrap: "wrap",
                      gap: "5px",
                      whiteSpace: "normal",
                      cursor: "pointer",
                      textDecorationLine: "underline",
                    }}
                    onClick={() => navigate("/politique")}
                  >
                    {" "}
                    Conditions générales d'utilisation
                  </StyleP>
                  {/* <StyleP
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      flexWrap: "wrap",
                      gap: "5px",
                      whiteSpace: "normal",
                      cursor: "pointer",
                      textDecorationLine: "underline",
                    }}
                    onClick={() => {
                      setIsOpen(true);
                    }}
                  >
                    {" "}
                    Conditions générales d'utilisation
                  </StyleP> */}
                </Column>

                <Column>
                  <SectionTitle>Localisation</SectionTitle>
                  <img
                    src={require("../../assets/img/Map5.webp")}
                    alt="Localisation"
                    style={{
                      maxWidth: "250px",
                      height: "auto",
                      borderRadius: "10px",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      window.open(
                        "https://www.google.com/maps/place/2+Av.+Lénine,+93230+Romainville,+France",
                        "_blank"
                      )
                    }
                  />
                </Column>
              </ColumnWrapper>
            </FooterContent>

            <LogoSection>
              <Link
                className="flexCenter animate pointer"
                to="home"
                smooth={true}
              >
                <img
                  alt="Logo Valacademy Formations"
                  src={require("../../assets/img/Logo/Logo02.png")}
                  style={{ marginLeft: -10 }}
                  width={100}
                  height={100}
                />
                {/* <h4 style={{ marginTop: 10, color: "white" }}> Val Academy</h4> */}
              </Link>
            </LogoSection>

            <BackToTop>
              <Link
                className="whiteColor animate pointer font13"
                to="home"
                smooth={true}
              >
                <i className="fas fa-arrow-up" />
                {" Retour en haut"}
              </Link>
            </BackToTop>
          </InnerWrapper>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
  background-color: #333;
  color: white;
  box-shadow: 0px -3px 8px rgba(0, 0, 0, 0.2);
`;

const InnerWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  width: 100%;
  padding: 20px 0;
  gap: 30px;
`;

const LogoSection = styled.div`
  display: flex;
  align-items: center;
`;

const FooterContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
`;

const ColumnWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  flex-wrap: wrap;
  gap: 40px;
`;

const Column = styled.div`
  flex: 1;
  min-width: 200px;
  max-width: 380px;
`;

const BackToTop = styled.div`
  margin-top: 20px;
  text-align: center;
`;

const StyleP = styled.p`
  font-size: 14px;
  color: white;
  margin: 8px 0;
  overflow-wrap: break-word; /* Ensures long words break */
  word-break: break-word;
  flex-wrap: wrap; /* Allow items to wrap */
`;

const SectionTitle = styled.h1`
  font-size: 16px;
  font-weight: bold;
  color: #f8a300;
  margin-bottom: 10px;
  text-transform: uppercase;
`;

const CertificationImageWrapper = styled.div`
  margin: 10px 0;
  display: flex;
  justify-content: center;
`;
